var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"h4 font-weight-bold"},[_vm._v("My Media")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('media-list',{attrs:{"user-id":_vm.user.id,"per-page":18}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }